import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../../services/data.service";
import moment from 'moment';
import {MessageService} from "../../../services/message.service";
import {LocalStorageService} from "../../../services/local-storage.service";
import {PaginationComponent} from "ngx-bootstrap/pagination";
import {RouterLink} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {DebounceKeyupDirective} from "../../../directives/debounce-keyup.directive";
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {StatusPipe} from "../../../pipes/status.pipe";

@Component({
    selector: 'app-task-list',
    templateUrl: './task-list.component.html',
    imports: [
        PaginationComponent,
        RouterLink,
        FormsModule,
        DebounceKeyupDirective,
        NgIf,
        NgForOf,
        StatusPipe,
        DatePipe
    ],
    styleUrl: './task-list.component.scss'
})
export class TaskListComponent implements OnInit {

    private dataService = inject(DataService);
    private messageService = inject(MessageService);
    private localStorageService = inject(LocalStorageService);

    paginConfig;
    entries;
    totalEntries;
    predicate;
    search;
    reverse;
    departments: any[];
    tasktypes: any[];

    ngOnInit(): void {
        const searchString = this.messageService.getItem('search', true);

        this.search = {
            title: searchString ?? '',
            status: 'all',
            creator: '',
            customer: '',
            contact: '',
            id_department: 'all',
            editor: '',
            id_tasktype: 'all',
        };

        let searchSaved = this.localStorageService.getItem('task-list');
        if (searchSaved) {
            this.search = {...this.search, ...searchSaved}
        }

        const status = this.messageService.getItem('task_list_status', true);
        if (status) {
            this.search.status = status;
        }

        this.paginConfig = {
            itemsPerPage: 25,
            page: 1
        };
        this.reverse = true;
        this.totalEntries = 0;
        this.predicate = 'created_at';
        this.listEntries(this.paginConfig);

        this.dataService.request('Department/listForUser').subscribe(response => {
            this.departments = response.departments;
        });

        this.dataService.request('Tasktype/listForLists').subscribe(response => {
            this.tasktypes = response.tasktypes;
        });
    }

    setOrder(order): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.localStorageService.setItem('task-list', this.search);

        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('Task/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            search: this.search,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.tasks;

            this.entries.forEach(entry => {
                entry.due_date_past = ['new', 'in_progress'].includes(entry.status) && moment(entry.due_date).isBefore(moment(), 'day')
            });
        });
    }

}
